import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    asyncGetLegalProceeding,
    asyncGetLegalProceedingsHistorical,
} from '../../../../../services/legalProceeding.service';
import {
    LegalProceeding,
    LegalProceedingAnnexes,
    LegalProceedingHistorical,
} from '../../../../../shared/types/legalProceedings/legalProceedings';
import { ACCOUNTS } from '../../../../../routes/paths';
import { FormikProps } from 'formik';

export const useLegalProceedingsDetail = () => {
    const navigate = useNavigate();
    const { idLegalProceeding } = useParams();
    const [loading, setLoading] = useState(false);
    const [legalProceeding, setLegalProceeding] = useState<LegalProceeding>();
    const [legalProceedingHistorical, setLegalProceedingHistorical] =
        useState<LegalProceedingHistorical[]>();
    const [formikLegalProceedingAnnexes, setFormikLegalProceedingAnnexes] =
        useState<FormikProps<LegalProceedingAnnexes>>();

    useEffect(() => {
        if (Boolean(idLegalProceeding?.trim())) {
            setLoading(true);
            asyncGetLegalProceeding(idLegalProceeding?.trim())
                .then((legalProceeding) => {
                    if (legalProceeding) setLegalProceeding(legalProceeding);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idLegalProceeding]);

    useEffect(() => {
        if (Boolean(idLegalProceeding?.trim())) {
            setLoading(true);
            asyncGetLegalProceedingsHistorical(idLegalProceeding?.trim())
                .then((legalProceedingHistorical) => {
                    if (legalProceedingHistorical)
                        setLegalProceedingHistorical(legalProceedingHistorical);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idLegalProceeding]);

    return {
        loading,
        legalProceeding,
        formikLegalProceedingAnnexes,
        legalProceedingHistorical,
        setFormikLegalProceedingAnnexes,
    };
};
